// UserDetails.jsx
import React, { useState } from "react";
import "../CSS/userDetail.css"; // Updated CSS file

import { FaProjectDiagram, FaSearch, FaEye, FaEdit } from "react-icons/fa";

const mockUsers = [
  {
    refId: "1",
    firstname: "Vibhoo",
    lastname: "Vishwakarma",
    email: "vibhoo@example.com",
    username: "vibhoo123",
    createdOn: "2024-01-01",
    createdBy: "Admin",
    progressId: "P001",
    status: "pending",
  },
  // More mock users if needed
];

const UserDetails = () => {
  const [users, setUsers] = useState(mockUsers);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [updateData, setUpdateData] = useState({
    newFirstname: "",
    newLastname: "",
    newEmail: "",
    newPassword: "",
  });

  const handleSearch = (e) => setSearchTerm(e.target.value);

  const filteredUsers = users.filter(
    (user) =>
      user.firstname.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.lastname.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const openViewModal = (user) => {
    setSelectedUser(user);
    setViewModalOpen(true);
  };

  const openUpdateModal = (user) => {
    setSelectedUser(user);
    setUpdateData({
      newFirstname: user.firstname,
      newLastname: user.lastname,
      newEmail: user.email,
      newPassword: "",
    });
    setUpdateModalOpen(true);
  };

  const closeModals = () => {
    setViewModalOpen(false);
    setUpdateModalOpen(false);
    setSelectedUser(null);
  };

  const handleUpdateChange = (e) => {
    const { id, value } = e.target;
    setUpdateData((prev) => ({ ...prev, [id]: value }));
  };

  const handleUpdateSubmit = (e) => {
    e.preventDefault();
    setUsers((prev) =>
      prev.map((user) =>
        user.refId === selectedUser.refId
          ? { ...user, ...updateData }
          : user
      )
    );
    closeModals();
  };

  return (
    <div className="uv-app-container">
      <main className="uv-main-content">
        <div className="uv-page-header">
          <h1 className="uv-page-title">
            <FaProjectDiagram className="uv-page-icon" /> User Details
          </h1>
          <div className="uv-search-group">
            <input
              type="search"
              className="uv-search-input"
              placeholder="Search users..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <button className="uv-search-btn">
              <FaSearch />
            </button>
          </div>
        </div>

        <div className="uv-table-container">
          <table className="uv-table">
            <thead>
              <tr>
                <th>Ref ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Username</th>
                <th>Created On</th>
                <th>Created By</th>
                <th>Progress ID</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user) => (
                <tr key={user.refId}>
                  <td>{user.refId}</td>
                  <td>{user.firstname}</td>
                  <td>{user.lastname}</td>
                  <td>{user.email}</td>
                  <td>{user.username}</td>
                  <td>{user.createdOn}</td>
                  <td>{user.createdBy}</td>
                  <td>{user.progressId}</td>
                  <td>
                    <button
                      className="uv-view-btn"
                      onClick={() => openViewModal(user)}
                    >
                      <FaEye />
                    </button>
                    <button
                      className="uv-update-btn"
                      onClick={() => openUpdateModal(user)}
                    >
                      <FaEdit />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* View Modal */}
        {viewModalOpen && selectedUser && (
          <div className="uv-modal">
            <div className="uv-modal-content">
              <span className="uv-close" onClick={closeModals}>

              </span>
              <h2>User Details</h2>
              <p>
                <strong>Ref ID:</strong> {selectedUser.refId}
              </p>
              <p>
                <strong>First Name:</strong> {selectedUser.firstname}
              </p>
              <p>
                <strong>Last Name:</strong> {selectedUser.lastname}
              </p>
              <p>
                <strong>Email:</strong> {selectedUser.email}
              </p>
              <p>
                <strong>Username:</strong> {selectedUser.username}
              </p>
              <p>
                <strong>Created On:</strong> {selectedUser.createdOn}
              </p>
              <p>
                <strong>Created By:</strong> {selectedUser.createdBy}
              </p>
              <p>
                <strong>Progress ID:</strong> {selectedUser.progressId}
              </p>
            </div>
          </div>
        )}

        {/* Update Modal */}
        {updateModalOpen && selectedUser && (
          <div className="uv-modal">
            <div className="uv-modal-content">
              <span className="uv-close" onClick={closeModals}>

              </span>
              <h2>Update User Details</h2>
              <form onSubmit={handleUpdateSubmit}>
                <input type="hidden" value={selectedUser.refId} />
                <label htmlFor="newFirstname">First Name:</label>
                <input
                  type="text"
                  id="newFirstname"
                  value={updateData.newFirstname}
                  onChange={handleUpdateChange}
                  required
                />
                <label htmlFor="newLastname">Last Name:</label>
                <input
                  type="text"
                  id="newLastname"
                  value={updateData.newLastname}
                  onChange={handleUpdateChange}
                  required
                />
                <label htmlFor="newEmail">Email:</label>
                <input
                  type="email"
                  id="newEmail"
                  value={updateData.newEmail}
                  onChange={handleUpdateChange}
                  required
                />
                <label htmlFor="newPassword">Password:</label>
                <input
                  type="password"
                  id="newPassword"
                  value={updateData.newPassword}
                  onChange={handleUpdateChange}
                  required
                />
                <button type="submit">Update</button>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default UserDetails;
